import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { ContactIcon } from 'src/resources/icons';
import ContactUsModal from '../modals/contactUsModal';
import { content } from 'src/common/lang/en-US';

const ContactUsButton: React.FC = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [visibleLetters, setVisibleLetters] = useState(0);
    const { contactUs } = content.footer.subHeadings;
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (isHovered) {
            setVisibleLetters(0);
            // SPEED UP the reveal:
            contactUs.split('').forEach((_, index) => {
                setTimeout(() => setVisibleLetters((prev) => prev + 1), index * 50);
            });
        } else {
            setVisibleLetters(0);
        }
    }, [isHovered, contactUs]);

    const handleModalClose = (): void => {
        setIsModalOpen(false);
    };

    const handleButtonClick = (): void => {
        setIsModalOpen(true);
        setIsHovered(false);
    };

    return (
        <>
            <Button
                onClick={handleButtonClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                sx={{
                    alignItems: 'center',
                    bgcolor: 'primary.main',
                    borderRadius: '80px',
                    bottom: 20,
                    color: 'primary.contrastText',
                    display: 'flex',
                    height: { xs: '80px', xxl: '150px' },
                    justifyContent: isHovered ? 'flex-start' : 'center',
                    overflow: 'hidden',
                    padding: isHovered ? '0 20px' : '0',
                    position: 'fixed',
                    right: 20,
                    transition: 'width 0.2s ease-in-out, padding 0.2s ease-in-out',
                    width: isHovered ? 'auto' : { xs: '80px', xxl: '150px' },
                }}
            >
                <Box
                    alignItems="center"
                    display="flex"
                    justifyContent="center"
                    pl={isHovered ? 2 : 0}
                    sx={{
                        '& svg': {
                            height: { xxl: 60 }, // Increased height for xxl
                            width: { xxl: 60 }, // Increased width for xxl
                        },
                    }}
                >
                    <ContactIcon />
                </Box>

                {isHovered && (
                    <Typography
                        ml={1.8}
                        mr={isHovered ? 2 : 0}
                        sx={{
                            display: 'flex',
                        }}
                        variant="body1_Bold"
                    >
                        {contactUs.split('').map((char, index) => (
                            <Box
                                component="span"
                                key={index}
                                sx={{
                                    minWidth: char === ' ' ? '5px' : 'auto',
                                    opacity: visibleLetters > index ? 1 : 0,
                                    transition: 'opacity 0.2s ease-in-out',
                                }}
                            >
                                {char}
                            </Box>
                        ))}
                    </Typography>
                )}
            </Button>
            {isModalOpen && <ContactUsModal onClose={handleModalClose} open={isModalOpen} />}
        </>
    );
};

export default ContactUsButton;
